
// Auto-generated file. Do not delete or modify.
import { pinFlowReducer } from "ouisys-engine/pinFlow";
import { oneClickFlowReducer } from "ouisys-engine/oneClickFlow";
const includedReducers: any = {
  pinFlow: pinFlowReducer,
  oneClickFlow: oneClickFlowReducer,
};
export default includedReducers;
